import axios from "axios";
import { apiGoalServicesURL } from "../utils/constants";
import { getToken } from "utils/utility";

const GoalServices = axios.create({
  baseURL: apiGoalServicesURL,
  withCredentials: true
});

GoalServices.interceptors.request.use(
  (config) => {
    const token = getToken();

    if (token)
      config.headers.Authorization = `Token ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

GoalServices.interceptors.response.use(
  (response) => {
    // return response.data
    return response;
  },
  (error) => {
    if (error && error?.response?.status === 403) {
      // Cookies.remove("lmos-token");
      window.location.pathname = "/";
    }
    if (error && error.response && error.response.status === 401) {
      // Cookies.remove("lmos-token");
    }
    return Promise.reject(error);
  }
);

export { GoalServices };

